import PropTypes from 'prop-types';
import styled from '@emotion/styled';

const ErrorList = styled('ul')`
  margin-top: 5px;

  li {
    color: ${({ theme }) => theme.errorColor};

    font-family: ${({ theme }) => theme.fontFamily};
    font-size: 13px;
    font-style: italic;
    font-weight: 300;

    line-height:17px;
  }
`;

const Errors = ({ errors }) => {
  if (!Array.isArray(errors) || errors.length < 1) {
    return null;
  }

  const errorItems = errors.map(error => <li key={error}>{error}</li>);

  return (
    <ErrorList>
      {errorItems}
    </ErrorList>
  );
}

Errors.propTypes = {
  errors: PropTypes.oneOfType([
    PropTypes.array,
    PropTypes.bool,
  ]),
};

Errors.defaultProps = {
  errors: null,
};

export default Errors;
